import { render, staticRenderFns } from "./pelunasan.vue?vue&type=template&id=21735b69&scoped=true&"
import script from "./pelunasan.vue?vue&type=script&lang=js&"
export * from "./pelunasan.vue?vue&type=script&lang=js&"
import style0 from "./pelunasan.vue?vue&type=style&index=0&id=21735b69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21735b69",
  null
  
)

export default component.exports